import React from 'react';
import { CheckIcon } from 'lucide-react';
export function SolucionSection() {
  const items = ['dónde se está fugando tu tiempo', 'qué actividades no generan crecimiento', 'qué puedes eliminar, reducir o delegar', 'cuántas horas podrías recuperar'];
  return <section className="bg-[#F5F5F5] py-16 md:py-24 px-4" data-id="element-151">
      <div className="max-w-4xl mx-auto" data-id="element-152">
        <div className="bg-white rounded-2xl shadow-sm p-8 md:p-12 border border-gray-100" data-id="element-153">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 text-center" data-id="element-154">
            Detecta tus fugas en un solo día
          </h2>

          <p className="text-xl text-gray-700 mb-8 text-center" data-id="element-155">
            Con este ejercicio descubrirás:
          </p>

          <ul className="space-y-4 max-w-2xl mx-auto mb-10" data-id="element-156">
            {items.map((item, index) => <li key={index} className="flex items-start gap-4 bg-gray-50 p-4 rounded-lg" data-id="element-157">
                <CheckIcon className="w-6 h-6 text-[#D90B10] flex-shrink-0 mt-0.5" data-id="element-158" />
                <span className="text-lg text-gray-800" data-id="element-159">{item}</span>
              </li>)}
          </ul>

          <p className="text-xl font-bold text-gray-900 text-center" data-id="element-160">
            Solo necesitas un día para hacerlo.
          </p>
        </div>
      </div>
    </section>;
}